import { NgModule } from '@angular/core';
import { COMMON_IMPORTS } from 'app/common-imports';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { RequestComponent } from 'lendio-borrower/components/borrower-details/workflow/request/request.component';
import { SharedModule } from 'app/shared-module';
import { SingleTaskChainComponent } from 'app/modules/borrower/components/borrower-details/workflow/workflow-tasks/single-task-chain/single-task-chain.component';
import { TaskComponent } from 'app/modules/borrower/components/borrower-details/workflow/workflow-tasks/task/task.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { TimeAgoModule } from 'app/pipes/time-ago/time-ago-pipe.module';
import { UserAvatarModule } from 'app/user-avatar/user-avatar.module';
import { WorkflowTasksComponent } from 'app/modules/borrower/components/borrower-details/workflow/workflow-tasks/workflow-tasks.component';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {FormlyModule} from '@ngx-formly/core';
import {ReactiveFormsModule} from '@angular/forms';
import { ContractRequestComponent } from 'lendio-borrower/components/borrower-details/workflow/contract-request/contract-request.component';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CollapsibleContainerModule } from 'ng2-app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';
import { ContractRequestDetailsComponent } from '../contract-request-details/contract-request-details.component';

@NgModule({
    declarations: [
        ContractRequestComponent,
        ContractRequestDetailsComponent,
        RequestComponent,
        SingleTaskChainComponent,
        TaskComponent,
        WorkflowTasksComponent,
    ],
    exports: [
        WorkflowTasksComponent,
        ContractRequestDetailsComponent
    ],
  imports: [
    CollapsibleContainerModule,
    COMMON_IMPORTS,
    CommonModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SharedModule,
    TimeAgoModule,
    UserAvatarModule,
    MatExpansionModule,
    TextFieldModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormlyModule,
    ReactiveFormsModule
  ],
  providers: [
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        appearance: 'outline',
        floatLabel: 'always',
      }
    }
  ]
})
export class InfoRequestsModule { }
